module.exports = __webpack_public_path__ + "static/img/-v-1.6b9924a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/-v-1.png
// module id = d/1O
// module chunks = 0